import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

import {
  MEDIA_CENTER_QUERY_KEYS,
  MEDIA_CENTER_RAILS_TYPE,
} from 'hb-react/frontoffice/apps/MediaCenter/utils/queryUtils';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { useFileLikes } from 'hb-react/shared/components/DesignSystem/Reactions/hooks/useFileLikes';
import { getLikesFromData } from 'hb-react/shared/components/DesignSystem/Reactions/utils/getLikesFromData';

export const useMediaLikes = ({ fileId, showReactions = true, showLikes }) => {
  const { currentUser } = useDefaultAppContexts();
  const queryClient = useQueryClient();

  const { data: dataLikes, isLoading: isLoadingLikes } = useFileLikes({
    fileId,
    userId: currentUser.id,
    queryKey: MEDIA_CENTER_QUERY_KEYS.likes,
    railsType: MEDIA_CENTER_RAILS_TYPE,
    showReactions: showLikes || showReactions,
  });

  const likes = useMemo(
    () =>
      getLikesFromData({
        dataLikes,
        currentUser,
        id: fileId,
      }),
    [dataLikes, currentUser, fileId],
  );

  const onLikeCallback = useCallback(() => {
    queryClient.removeQueries({
      queryKey: [MEDIA_CENTER_QUERY_KEYS.likes, fileId],
    });
  }, [queryClient, fileId]);

  return {
    likes,
    isLoadingLikes,
    onLikeCallback,
  };
};
